export default __webpack_public_path__ + "static/media/5406715.389bb3df.jpg";